
import { BlockType } from '@apps/web/src/blocks';

export const getBlockId = (block: BlockType) => {
	return `block_${block.contentAlias}-${block.key}`;
};
